/* UNTAINED storefront V2: drawers, bag, size selection, gallery counter. No dependencies. */
(function () {
  'use strict';

  var routes = (window.v2 && window.v2.routes) || {
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    root: '/'
  };
  var scrim = document.querySelector('[data-v2-scrim]');
  var openDrawer = null;
  var lastFocus = null;

  /* Funnel events that Shopify does not emit itself: size_selected,
     size_guide_opened, add_to_bag_clicked, cart_drawer_opened. Each fires once
     per visitor action (never on page load or back navigation). They go to
     Shopify Customer Events (Shopify.analytics.publish, read by custom pixels)
     and, when Clarity is loaded, to Clarity as custom events and tags.
     page_viewed, product_viewed, product_added_to_cart, cart_viewed and
     checkout_* are Shopify standard events and are not duplicated here. */
  var productHandle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';

  function emitEvent(name, data) {
    var payload = data || {};
    payload.product_handle = payload.product_handle || productHandle;
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (problem) {}
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (typeof window.clarity === 'function' && privacy &&
          privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed() === true) {
        window.clarity('event', name);
        if (payload.size) window.clarity('set', 'size', payload.size);
      }
    } catch (problem) {}
  }

  function drawer(name) {
    return document.getElementById(name === 'cart' ? 'v2-cart' : 'v2-nav');
  }

  function open(name) {
    var el = drawer(name);
    if (!el) return false;
    close();
    lastFocus = document.activeElement;
    el.hidden = false;
    if (scrim) scrim.hidden = false;
    document.body.classList.add('v2-locked');
    openDrawer = el;
    var trigger = document.querySelector('[data-v2-open="' + name + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusable = el.querySelector('[data-v2-close]');
    if (focusable) focusable.focus();
    return true;
  }

  function close() {
    if (!openDrawer) return;
    openDrawer.hidden = true;
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('v2-locked');
    document.querySelectorAll('[data-v2-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
    openDrawer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(count) {
    document.querySelectorAll('[data-v2-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    var pieces = parseInt(count, 10) === 1 ? ' piece' : ' pieces';
    document.querySelectorAll('[data-v2-cart-pieces]').forEach(function (el) {
      el.textContent = parseInt(count, 10) + pieces;
    });
  }

  function refreshCart() {
    var url = routes.root + '?sections=v2-cart-drawer';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var html = sections['v2-cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-v2-cart-contents]');
        var count = doc.querySelector('[data-v2-cart-count]');
        if (fresh) {
          document.querySelectorAll('[data-v2-cart-contents]').forEach(function (el) {
            el.innerHTML = fresh.innerHTML;
          });
        }
        if (count) setCount(count.textContent);
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong.');
        return data;
      });
    });
  }

  function changeLine(key, quantity) {
    var holders = document.querySelectorAll('[data-v2-cart-contents]');
    holders.forEach(function (el) {
      el.classList.add('v2-cart--busy');
    });
    return post(routes.cartChange, { id: key, quantity: quantity })
      .then(refreshCart)
      .catch(function () {
        window.location.href = '/cart';
      })
      .then(function () {
        holders.forEach(function (el) {
          el.classList.remove('v2-cart--busy');
        });
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest(
      '[data-v2-open], [data-v2-close], [data-v2-scrim], [data-v2-qty], [data-v2-dialog-open], [data-v2-dialog-close]'
    );
    if (!target) return;

    if (target.hasAttribute('data-v2-open')) {
      var drawerName = target.getAttribute('data-v2-open');
      if (open(drawerName)) {
        event.preventDefault();
        if (drawerName === 'cart') emitEvent('cart_drawer_opened', { trigger: 'header' });
      }
      return;
    }
    if (target.hasAttribute('data-v2-close') || target.hasAttribute('data-v2-scrim')) {
      event.preventDefault();
      close();
      return;
    }
    if (target.hasAttribute('data-v2-qty')) {
      var line = target.closest('[data-v2-line]');
      if (!line) return;
      event.preventDefault();
      changeLine(line.getAttribute('data-v2-line'), parseInt(target.getAttribute('data-v2-qty'), 10));
      return;
    }
    if (target.hasAttribute('data-v2-dialog-open')) {
      var dialog = document.getElementById(target.getAttribute('data-v2-dialog-open'));
      if (dialog && dialog.showModal) {
        dialog.showModal();
        if (dialog.id === 'v2-size-guide') emitEvent('size_guide_opened');
      }
      return;
    }
    if (target.hasAttribute('data-v2-dialog-close')) {
      var parent = target.closest('dialog');
      if (parent) parent.close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  document.querySelectorAll('dialog.v2-dialog').forEach(function (dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  });

  /* Product form */
  var form = document.querySelector('[data-v2-product-form]');
  if (form) {
    var submit = form.querySelector('[data-v2-submit]');
    var stickySubmit = document.querySelector('[data-v2-sticky-submit]');
    var error = form.querySelector('[data-v2-form-error]');
    var sizes = form.querySelector('.v2-sizes');
    var radios = form.querySelectorAll('input[type="radio"][name="id"]');

    var setLabel = function (text) {
      if (submit && !submit.disabled) submit.textContent = text;
      if (stickySubmit) stickySubmit.textContent = text;
    };

    var selected = function () {
      return form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
    };

    /* The button always reads Add to bag; choosing a size only switches it
       from muted to active and names the size beside the legend. */
    var sizeState = form.querySelector('[data-v2-size-state]');
    var sizeHint = form.querySelector('[data-v2-size-hint]');

    var syncSize = function () {
      var radio = form.querySelector('input[type="radio"][name="id"]:checked');
      if (!radio) return;
      if (sizes) sizes.classList.remove('v2-sizes--prompt');
      if (error) error.hidden = true;
      [submit, stickySubmit].forEach(function (button) {
        if (button) button.removeAttribute('aria-disabled');
      });
      if (sizeHint) sizeHint.hidden = true;
      var name = radio.parentNode.querySelector('span');
      if (sizeState && name) sizeState.textContent = ' · ' + name.textContent.trim();
      var price = radio.getAttribute('data-price');
      if (price) {
        document.querySelectorAll('[data-v2-price]').forEach(function (el) {
          el.innerHTML = price;
        });
      }
    };

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncSize();
        var name = radio.parentNode.querySelector('span');
        emitEvent('size_selected', {
          size: name ? name.textContent.trim() : '',
          variant_id: radio.value
        });
      });
    });
    /* A size restored by the browser on back navigation counts as chosen. */
    syncSize();
    window.addEventListener('pageshow', syncSize);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var choice = selected();
      /* A press before a size is chosen is the CTA-confusion signal. */
      emitEvent('add_to_bag_clicked', {
        size_chosen: !!choice,
        variant_id: choice ? choice.value : '',
        source: event.submitter && event.submitter.hasAttribute('data-v2-sticky-submit') ? 'sticky' : 'main'
      });
      if (!choice) {
        if (sizes) {
          sizes.classList.add('v2-sizes--prompt');
          sizes.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        if (error) {
          error.textContent = 'Select a size to continue.';
          error.hidden = false;
        }
        return;
      }
      var label = submit.getAttribute('data-label-add');
      setLabel(submit.getAttribute('data-label-adding'));
      submit.setAttribute('aria-busy', 'true');
      post(routes.cartAdd, { items: [{ id: parseInt(choice.value, 10), quantity: 1 }] })
        .then(refreshCart)
        .then(function () {
          open('cart');
        })
        .catch(function (problem) {
          if (error) {
            error.textContent = problem.message;
            error.hidden = false;
          }
        })
        .then(function () {
          submit.removeAttribute('aria-busy');
          setLabel(label);
        });
    });

    /* Sticky bar appears once the main button has scrolled out of view. */
    var sticky = document.querySelector('[data-v2-sticky]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }).observe(submit);
    }
  }

  /* Cookie consent: Shopify decides, from the shop's privacy settings and the
     visitor's region, whether a banner is required at all. */
  var consent = document.querySelector('[data-v2-consent]');
  if (consent && window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (problem) {
        var privacy = window.Shopify.customerPrivacy;
        if (problem || !privacy || !privacy.shouldShowBanner()) return;
        consent.hidden = false;
        consent.addEventListener('click', function (event) {
          var choice = event.target.closest('[data-v2-consent-choice]');
          if (!choice) return;
          var allow = choice.getAttribute('data-v2-consent-choice') === 'accept';
          privacy.setTrackingConsent(
            { analytics: allow, marketing: allow, preferences: allow, sale_of_data: allow },
            function () {
              consent.hidden = true;
            }
          );
        });
      }
    );
  }

  /* Mobile gallery counter */
  var track = document.querySelector('[data-v2-gallery-track]');
  var index = document.querySelector('[data-v2-gallery-index]');
  if (track && index) {
    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          index.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
          ticking = false;
        });
      },
      { passive: true }
    );
  }
})();
